export enum InlineSearchCommands {
	INLINE_SEARCH_READY_EVENT = 'InlineSearch:ReadyEvent',
	INLINE_SEARCH_APP_RENDER_EVENT = 'InlineSearch:AppRenderEvent',
	INLINE_SEARCH_APP_USER_INPUT_EVENT = 'InlineSearch:AppUserInputEvent',
	INLINE_SEARCH_APP_CLEAR_INPUT_EVENT = 'InlineSearch:AppClearInputEvent',
	INLINE_SEARCH_APP_INITIAL_INPUT_EVENT = 'InlineSearch:AppInitialInputEvent',
	INLINE_SEARCH_SUGGESTION_CLICK_EVENT = "InlineSearch:SuggestionClickEvent",
	INLINE_SEARCH_SEND_EVENT = "InlineSearch:SendEvent",
	INLINE_SEARCH_APP_USER_KEYBOARD_EVENT = 'InlineSearch:AppUserKeyboardEvent'
}